import GoodsStock from "./pages/warehouseManage/goodsStock";
import Warsehouse from "./pages/warehouseManage/warsehouse";
import InWarehousLog from "./pages/warehouseManage/inWarehousLog";
import OutWarehousLog from "./pages/warehouseManage/outWarehousLog";
import LotteryPolymerize from "./pages/activeManage/lotteryPolymerize";
import HomeLotteryPolymerize from "./pages/activeManage/homeLotteryPolymerize";
import HomeLotteryPolymerizeCreate from "./pages/activeManage/homeLotteryPolymerizeCreate";
import WeekActive from "./pages/activeManage/weekActive";
import WeekActiveCreate from "./pages/activeManage/weekActiveCreate";
import LotteryAction from "./pages/lotteryManage/lotteryAction";
import Redeem from "./pages/lotteryManage/redeem";
import GoodsRoot from "./pages/goodsManage/goodsRoot";
import GoodsType from "./pages/goodsManage/goodsType";
import LineGoods from "./pages/hallManage/lineGoods";
import Worker from "./pages/workerManage/worker";
import GoodsActivity from "./pages/activityManage/goodsActivity";
import Cashier from "./pages/cashier";

export const baseAdminPath = "admin";
export const baseClientPath = "client";

export const routesAdminData = [
  {
    title: "活动管理",
    path: "activeManage",
    children: [
      {
        title: "所有活动列表",
        path: "lotteryPolymerize",
        breadcrumb: [{ title: "活动管理" }, { title: "活动列表" }],
        element: <LotteryPolymerize />,
      },
      {
        title: "首页推荐活动",
        path: "homeLotteryPolymerize",
        breadcrumb: [{ title: "活动管理" }, { title: "首页推荐活动" }],
        element: <HomeLotteryPolymerize />,
      },
      {
        title: "首页推荐活动新增",
        path: "homeLotteryPolymerizeCreate",
        breadcrumb: [{ title: "活动管理" }, { title: "首页推荐活动新增" }],
        element: <HomeLotteryPolymerizeCreate />,
      },
      {
        title: "每周活动",
        path: "weekActive",
        breadcrumb: [{ title: "活动管理" }, { title: "每周活动" }],
        element: <WeekActive />,
      },
      {
        title: "每周活动新增",
        path: "weekActiveCreate",
        breadcrumb: [{ title: "活动管理" }, { title: "每周活动新增" }],
        element: <WeekActiveCreate />,
      },
    ],
  },
  {
    title: "抽奖管理",
    path: "lotteryManage",
    children: [
      {
        title: "活动列表",
        path: "lotteryPolymerize",
        breadcrumb: [{ title: "抽奖管理" }, { title: "活动列表" }],
        element: <LotteryPolymerize />,
      },
      {
        title: "抽奖操作",
        path: "lotteryAction",
        breadcrumb: [{ title: "抽奖管理" }, { title: "抽奖操作" }],
        element: <LotteryAction />,
      },
      {
        title: "兑奖",
        path: "redeem",
        breadcrumb: [{ title: "抽奖管理" }, { title: "兑奖" }],
        element: <Redeem />,
      },
    ],
  },
  // {
  //   title: "商品管理",
  //   path: "goodsManage",
  //   children: [
  //     {
  //       title: "商品字典",
  //       path: "goodsRoot",
  //       breadcrumb: [{ title: "商品管理" }, { title: "字典管理" }],
  //       element: <GoodsRoot />,
  //     },
  //     {
  //       title: "商品类型",
  //       path: "goodsType",
  //       breadcrumb: [{ title: "商品管理" }, { title: "商品类型" }],
  //       element: <GoodsType />,
  //     },
  //   ],
  // },
  // {
  //   title: "仓库管理",
  //   path: "warehouseManage",
  //   children: [
  //     {
  //       title: "库房管理",
  //       path: "wareHouse",
  //       breadcrumb: [{ title: "仓库管理" }, { title: "库房管理" }],
  //       element: <Warsehouse />,
  //     },
  //     {
  //       title: "库存管理",
  //       path: "goodsStock",
  //       breadcrumb: [{ title: "仓库管理" }, { title: "库存管理" }],
  //       element: <GoodsStock />,
  //     },
  //     {
  //       title: "入库记录",
  //       path: "inWarehousLog",
  //       breadcrumb: [{ title: "仓库管理" }, { title: "入库记录" }],
  //       element: <InWarehousLog />,
  //     },
  //     {
  //       title: "出库记录",
  //       path: "outWarehousLog",
  //       breadcrumb: [{ title: "仓库管理" }, { title: "出库记录" }],
  //       element: <OutWarehousLog />,
  //     },
  //   ],
  // },
  // {
  //   title: "售货大厅管理",
  //   path: "hallManage",
  //   children: [
  //     {
  //       title: "大厅商品",
  //       path: "lineGoods",
  //       breadcrumb: [{ title: "售货大厅管理" }, { title: "大厅商品" }],
  //       element: <LineGoods />,
  //     },
  //   ],
  // },
  // {
  //   title: "人员管理",
  //   path: "workerManage",
  //   children: [
  //     {
  //       title: "员工管理",
  //       path: "worker",
  //       breadcrumb: [{ title: "人员管理" }, { title: "员工管理" }],
  //       element: <Worker />,
  //     },
  //   ],
  // },
  // {
  //   title: "活动管理",
  //   path: "activityManage",
  //   children: [
  //     {
  //       title: "商品活动",
  //       path: "goodsActivity",
  //       breadcrumb: [{ title: "活动管理" }, { title: "商品活动" }],
  //       element: <GoodsActivity />,
  //     },
  //   ],
  // },
];

export const routesClientData = [
  {
    title: "收银台",
    path: "cashier",
    element: <Cashier />,
  },
];
